import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
  Users, Users2, GitBranch, PlayCircle, LayoutTemplate,
  BookOpen, Wrench, PlugZap, BarChart3, Settings2, Lock, Swords
} from "lucide-react";

const NAV = [
  { to: "/workforce",           label: "My Workforce", icon: Users,          phase: 1 },
  { to: "/workforce/analytics", label: "Analytics",    icon: BarChart3,      phase: 1 },
  { to: "/workforce/teams",     label: "Teams",        icon: Users2,         phase: 2 },
  { to: "/workforce/debate",    label: "Debate",       icon: Swords,         phase: 2 },
  { to: "/workforce/workflows", label: "Workflows",    icon: GitBranch,      phase: 3, badge: "New" },
  { to: "/workforce/runs",      label: "Runs",         icon: PlayCircle,     phase: 3, badge: "New" },
  { to: "/workforce/templates", label: "Templates",    icon: LayoutTemplate, phase: 2 },
  { to: "/workforce/knowledge", label: "Knowledge",    icon: BookOpen,       phase: 2 },
  { to: "/workforce/tools",     label: "Tools",        icon: Wrench,         phase: 1, badge: "New" },
  { to: "/workforce/providers", label: "Providers",    icon: PlugZap,        phase: 1 },
  { to: "/workforce/settings",  label: "Settings",     icon: Settings2,      phase: 1, badge: "New" },
];

export default function WorkforceLayout() {
  const location = useLocation();
  // Don't show the sub-nav on individual worker pages (they get full space)
  const showSubNav = !/\/workforce\/worker\//.test(location.pathname) && !/\/workforce\/new/.test(location.pathname);

  return (
    <div className="min-h-screen">
      {showSubNav && (
        <div className="border-b-2 border-slate-900 bg-white sticky top-0 z-10">
          <div className="flex overflow-x-auto no-scrollbar px-4 gap-1" data-testid="workforce-subnav">
            {NAV.map(({ to, label, icon: Icon, phase, badge }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/workforce"}
                data-testid={`wf-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-3 whitespace-nowrap font-heading font-bold text-sm transition-all border-b-4 ${
                    isActive ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-900"
                  }`
                }
              >
                <Icon size={16} strokeWidth={2.5} />
                {label}
                {badge ? (
                  <span className="text-[9px] uppercase tracking-widest bg-emerald-400 text-slate-900 border border-slate-900 px-1.5 py-0.5 rounded-full font-bold">
                    {badge}
                  </span>
                ) : phase > 1 && (
                  <span className="text-[9px] uppercase tracking-widest bg-amber-200 text-slate-900 border border-slate-900 px-1.5 py-0.5 rounded-full font-bold flex items-center gap-0.5">
                    <Lock size={8} strokeWidth={3} /> Phase {phase}
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      )}
      <Outlet />
    </div>
  );
}
